import { render } from "./user_forgotpass.vue?vue&type=template&id=701d293b"
import script from "./user_forgotpass.vue?vue&type=script&lang=js"
export * from "./user_forgotpass.vue?vue&type=script&lang=js"

import "./user_forgotpass.vue?vue&type=style&index=0&id=701d293b&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__